import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from "vue";
import { formatAmount, ITokenDistribution } from "@/shared";
import HolderDistributionRow from "@/components/trade/HolderDistributionRow.vue";

// props
interface IProps {
	mint: string;
	displayUsd: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HolderDistribution',
  props: {
    mint: null,
    displayUsd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	mint: string;
	displayUsd: boolean;
};



//data
let refreshInterval = null;
const tokenDistribution = ref<ITokenDistribution | null>(null);

//methods
async function mounted(): Promise<void> {
	getDistribution(props.mint);
	refreshInterval = setInterval(() => {
		getDistribution(props.mint);
	}, 30_000);
}

async function getDistribution(mint: string): Promise<void> {
	const data = await fetch(
		`https://data.fluxbeam.xyz/tokens/${mint}/holders/distribution`
	);
	if (!data) return;

	//@ts-ignore
	tokenDistribution.value = await data.json();
}

// setup
onMounted(mounted);
onUnmounted(() => {
	clearInterval(refreshInterval);
});

return { __sfc: true,props, refreshInterval, tokenDistribution, mounted, getDistribution, formatAmount, HolderDistributionRow }
}

})